import { findExistingChannel, leaveAllEchoChannels } from '@/helpers/echoConfig'

const PRIVATE_CHANNEL_PREFIXES = [
  'notifications_',
  'dashboard_',
  'data_staff_',
  'data_project_',
  'data_project_user_',
  'measure_import_',
]

export function isPrivateChannel(channel) {
  if (!channel || channel === 'public') return false

  return PRIVATE_CHANNEL_PREFIXES.some(prefix => channel.startsWith(prefix))
}

export default function useEvent() {
  function getChannelInstance(channel, isPrivate = false) {
    if (!window?.Echo) return null

    const shouldBePrivate = isPrivate || isPrivateChannel(channel)

    return shouldBePrivate ? window.Echo.private(channel) : window.Echo.channel(channel)
  }

  function addEventListener(channel = 'public', event = null, listener = null, isPrivate = false) {
    if (import.meta.client) {
      getChannelInstance(channel, isPrivate)?.listen(event, listener)
    }
  }

  function removeEventListener(channel, event, listener = null, isPrivate = false) {
    if (import.meta.client) {
      const shouldBePrivate = isPrivate || isPrivateChannel(channel)
      const existingChannel = findExistingChannel(window?.Echo, channel, shouldBePrivate)

      if (existingChannel) {
        existingChannel.stopListening(event, listener)
      }
    }
  }

  function addPrivateListener(channel, event, listener) {
    addEventListener(channel, event, listener, true)
  }

  function removePrivateListener(channel, event, listener = null) {
    removeEventListener(channel, event, listener, true)
  }

  function leaveAllChannels() {
    if (import.meta.client) {
      leaveAllEchoChannels(window?.Echo)
    }
  }

  return {
    addEventListener,
    removeEventListener,
    addPrivateListener,
    removePrivateListener,
    leaveAllChannels,
  }
}
